/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The RefreshTokenDto model module.
 * @module model/RefreshTokenDto
 * @version v0
 */
class RefreshTokenDto {
    /**
     * Constructs a new <code>RefreshTokenDto</code>.
     * @alias module:model/RefreshTokenDto
     */
    constructor() { 
        
        RefreshTokenDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>RefreshTokenDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RefreshTokenDto} obj Optional instance to populate.
     * @return {module:model/RefreshTokenDto} The populated <code>RefreshTokenDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RefreshTokenDto();

            if (data.hasOwnProperty('token')) {
                obj['token'] = ApiClient.convertToType(data['token'], 'String');
            }
            if (data.hasOwnProperty('refreshToken')) {
                obj['refreshToken'] = ApiClient.convertToType(data['refreshToken'], 'String');
            }
            if (data.hasOwnProperty('tokenExpiresAt')) {
                obj['tokenExpiresAt'] = ApiClient.convertToType(data['tokenExpiresAt'], 'Date');
            }
            if (data.hasOwnProperty('refreshTokenExpiresAt')) {
                obj['refreshTokenExpiresAt'] = ApiClient.convertToType(data['refreshTokenExpiresAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>RefreshTokenDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RefreshTokenDto</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['token'] && !(typeof data['token'] === 'string' || data['token'] instanceof String)) {
            throw new Error("Expected the field `token` to be a primitive type in the JSON string but got " + data['token']);
        }
        // ensure the json data is a string
        if (data['refreshToken'] && !(typeof data['refreshToken'] === 'string' || data['refreshToken'] instanceof String)) {
            throw new Error("Expected the field `refreshToken` to be a primitive type in the JSON string but got " + data['refreshToken']);
        }

        return true;
    }


}



/**
 * @member {String} token
 */
RefreshTokenDto.prototype['token'] = undefined;

/**
 * @member {String} refreshToken
 */
RefreshTokenDto.prototype['refreshToken'] = undefined;

/**
 * @member {Date} tokenExpiresAt
 */
RefreshTokenDto.prototype['tokenExpiresAt'] = undefined;

/**
 * @member {Date} refreshTokenExpiresAt
 */
RefreshTokenDto.prototype['refreshTokenExpiresAt'] = undefined;






export default RefreshTokenDto;

